// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"dddc7164","174":"c47618c6","184":"52f98b07","787":"69cbd938"}[chunkId] + ".chunk.js";
};